import { RouteConfig } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ListView from '../views/ListView.vue'
import ReadView from '../views/ReadView.vue'
import WriteView from '../views/WriteView.vue'
const Mail = () => import(/* webpackChunkName: "mail" */ '@home/Index.vue')
const MailMaster = () => import(/* webpackChunkName: "mail" */ '@home/views/Master.vue')

const routes: RouteConfig[] = [
  {
    path: '/mail',
    component: Mail,
    children: [
      {
        path: '',
        component: MailMaster,
        children: [
          {
            path: 'home',
            name: 'mail-home',
            component: HomeView,
          },
          {
            path: 'list',
            name: 'mail-list',
            component: ListView,
          },
          {
            path: 'read',
            name: 'mail-read',
            component: ReadView,
          },
          {
            path: 'write',
            name: 'mail-write',
            component: WriteView,
          },
        ],
      },
      {
        path:'',
        redirect: 'home'
      }
    ],
  },
]
export default routes
